import CachedIcon from '@mui/icons-material/Cached';
import { Card, CardContent, CardHeader, CircularProgress, IconButton, Typography } from "@mui/material";
import * as React from "react";
import { connect } from "react-redux";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { disabledRefreshAllBtnStyle, disabledRefreshSuccessIconStyles, enableRefreshAllBtnStyle, enableRefreshSuccessIconStyles, pollingColStyle, pollingColStyleTitle } from '../../styles';
import FetchHelper from '../../FetchHelper';
import { actionCreators, ApplicationState, FetchState, selectors } from '../../../store';
import { padZeroToStart } from '../../../utils';

const NO_OF_POLLING_TOPIC = 3;
const params = {
    mainid: "",
    isRefreshAllBegin: 0,
    isRefreshAllCompleted: (status: number) => { },
    loadingRefreshAll: [false],
    setDisabledRefreshGroupBtn: (disabled: boolean, name: string) => { },
    isRefreshGroup: false,
    setRefreshGroup: (refreshGroup: boolean, name: string) => { },
    isDisbleRefeshBtn: true,
    centralId: "",
    deviceNo: "",
}

export interface ConnectionInfomationModel {
    mainid: string,
    deviceNo: string,
    conCount: string,
    gatewayConStatus: string,
    gatewayRssi: string,
    peripherals: PeripheralsModel[],
    lastGetDatetime: string,
}

interface PeripheralsModel {
    mainid: string,
    conStatus: string,
    rssi: string,
}

type LoRaConnectionStatusProps = {
    defaultData: ConnectionInfomationModel | undefined;
    isRefreshSuccessDeviceNo?: boolean;
    onRefreshComplete?: () => void;
};

export type PureLoRaConnectionStatusProps = LoRaConnectionStatusProps & ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps & typeof params;

const fetchId = "CONNECTION_INFORMATION_FETCH";
export const LoRaConnectionStatus_TJ360VersionDevice = (props: PureLoRaConnectionStatusProps) => {
    const { deviceNo, centralId, defaultData, fetchState, mainid, isRefreshAllBegin, loadingRefreshAll, isRefreshGroup, isDisbleRefeshBtn, isRefreshSuccessDeviceNo } = props;
    const { onError, onRefresh, isRefreshAllCompleted, setDisabledRefreshGroupBtn, setRefreshGroup } = props;
    const [connectionInformation, setConnectionInformation] = React.useState<ConnectionInfomationModel | null>(props.fetchState.data);
    const [refreshFlg, setRefreshFlg] = React.useState(false);
    const [isFetchAll, setIsFetchAll] = React.useState(false);
    const [isRefreshSuccess, setIsRefreshSuccess] = React.useState(false);

    React.useEffect(() => {
        if(!isRefreshSuccessDeviceNo)
            setIsRefreshSuccess(false);
    }, [isRefreshSuccessDeviceNo]);

    // パラメータ設定
    const handleFetchParams = () => {
        const params = new Map<string, any>();
        const code = "PM";
        params.set("code", code);
        params.set("mainid", mainid);
        params.set("centralid", centralId);
        params.set("device_no", deviceNo);
        return params;
    }

    // デマンド現在値取得成功時
    const handleFetchSuccess = (data: any, isClickedRefreshBtn: boolean) => {
        setRefreshFlg(false);
        const resData = {
            mainid: data.mainid,
            deviceNo: data.device_no,
            conCount: data.con_count,
            gatewayConStatus: data.gateway_con_status,
            gatewayRssi: data.gateway_rssi,
            peripherals: data.peripherals.map((peripheral: any) => ({
                mainid: peripheral.mainid,
                conStatus: peripheral.con_status,
                rssi: peripheral.rssi,
            })),
            lastGetDatetime: data.last_get_datetime,
        } as ConnectionInfomationModel;
        setConnectionInformation(resData);
        setRefreshFlg(false);
        setIsFetchAll(false);
        isClickedRefreshBtn && setIsRefreshSuccess(true);
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);
    };

    const handleError = (success: boolean, data: any, error: any) => {
        setRefreshFlg(false);
        onError(success, data, error);
        if (isRefreshAllBegin !== 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);
        setIsRefreshSuccess(false);
    }

    const handleRefresh = () => {
        setRefreshFlg(true);
        setIsRefreshSuccess(false);
        const params = handleFetchParams();
        onRefresh(params);
    };

    const handleRefreshSuccess = (data: any, fetchId: string) => {
        handleFetchSuccess(data, true);
        props.onRefreshComplete?.();
    }

    const refreshAll = () => {
        if (isRefreshAllBegin === NO_OF_POLLING_TOPIC) {
            console.log("fetch No:______" + isRefreshAllBegin);
            handleRefresh();
        }
        isRefreshGroup && handleRefresh();
        isRefreshAllBegin > 0 || isRefreshGroup ? setRefreshFlg(true) : setRefreshFlg(false);
    }
    // eslint-disable-next-line
    React.useEffect(refreshAll, [isRefreshAllBegin, isRefreshGroup]);

    React.useEffect(() => {
        setDisabledRefreshGroupBtn(refreshFlg, fetchId);
        // eslint-disable-next-line
    }, [refreshFlg]);

    React.useEffect(() => {
        defaultData && handleFetchSuccess(defaultData, false);
        if(!defaultData) {
            setConnectionInformation(null);
        }
        // eslint-disable-next-line
    }, [defaultData]);

    return (
        <>
            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            <IconButton aria-label="refresh" onClick={handleRefresh} disabled={isDisbleRefeshBtn || refreshFlg || isFetchAll}>
                                <CachedIcon fontSize="medium" style={isDisbleRefeshBtn || refreshFlg || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title='Connection情報'
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0' }}>
                    {(fetchState.loading || loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className={'polling'} style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={pollingColStyleTitle}>接続台数</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Gateway 接続状態</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Gateway RSSI 電波強度</td>
                                    </tr>
                                    {connectionInformation?.peripherals.map((peripheral, index) => (
                                    <>
                                        <tr>
                                            <td style={pollingColStyleTitle}>Peripheral{index + 1 < 10 ? '0' + (index + 1) : index + 1}-端末名称</td>
                                        </tr>
                                        <tr>
                                            <td style={pollingColStyleTitle}>Peripheral{index + 1 < 10 ? '0' + (index + 1) : index + 1}-接続状態</td>
                                        </tr>
                                        <tr>
                                            <td style={pollingColStyleTitle}>Peripheral{index + 1 < 10 ? '0' + (index + 1) : index + 1}-RSSI 電波強度</td>
                                        </tr>
                                    </>
                                ))}
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className={'polling'} style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={pollingColStyleTitle}>接続台数</td>
                                    <td style={pollingColStyle}>{connectionInformation?.conCount}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Gateway 接続状態</td>
                                    <td style={pollingColStyle}>
                                        {
                                            connectionInformation?.gatewayConStatus == '0'
                                            ? '未接続'
                                            : connectionInformation?.gatewayConStatus == '1'
                                            ? '接続'
                                            : ''
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Gateway RSSI 電波強度</td>
                                    <td style={pollingColStyle}>{connectionInformation?.gatewayRssi}</td>
                                </tr>
                                {connectionInformation?.peripherals.map((peripheral, index) => (
                                    <>
                                        <tr>
                                            <td style={pollingColStyleTitle}>Peripheral{index + 1 < 10 ? '0' + (index + 1) : index + 1}-端末名称</td>
                                            <td style={pollingColStyle}>{peripheral.mainid}</td>
                                        </tr>
                                        <tr>
                                            <td style={pollingColStyleTitle}>Peripheral{index + 1 < 10 ? '0' + (index + 1) : index + 1}-接続状態</td>
                                            <td style={pollingColStyle}>{peripheral.conStatus == '0' ? "未接続" : "接続" }</td>
                                        </tr>
                                        <tr>
                                            <td style={pollingColStyleTitle}>Peripheral{index + 1 < 10 ? '0' + (index + 1) : index + 1}-RSSI 電波強度</td>
                                            <td style={pollingColStyle}>{peripheral.rssi}</td>
                                        </tr>
                                    </>
                                ))}
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{connectionInformation?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >
            <FetchHelper fetchId={fetchId} onComplete={(success, data, error) => success ? handleRefreshSuccess(data, fetchId) : handleError(success, data, error)} />
        </>
    );
};
const mapStateToProps = (state: ApplicationState) => ({
    fetchState: selectors.getFetchState(
        state,
        fetchId
    ) as FetchState,
});
const mapDispatchToProps = {
    onRefresh: (params: any) => actionCreators.fetch(fetchId, `/polling-nrf/get`, "GET", params),
    onError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: "Connection情報取得",
            body: "Connection情報取得できませんでした。",
        }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoRaConnectionStatus_TJ360VersionDevice);


